import { AdminTemplate } from "../../components";
import { SalesmanMonthlyDataTable } from "../../components/organisms/salesman/SalesmanMonthlyDataTable";

export const SalesmanMonthlyDataPage = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Aylık Satış Performans Raporu",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}
        >
            <SalesmanMonthlyDataTable />
        </AdminTemplate>
    );
};
